import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxSpinnerModule } from 'ngx-spinner';
import { DataTablesModule } from 'angular-datatables';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { UserIdRequestFlowDynamicComponent } from './user-id-request-flow-dynamic/user-id-request-flow-dynamic.component';
import { RacLifeCycleComponent } from './rac-life-cycle/rac-life-cycle.component';

@NgModule({
  declarations: [
    RacLifeCycleComponent,
    UserIdRequestFlowDynamicComponent
  ] ,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    DataTablesModule,
    BsDatepickerModule],
  
  providers: []
})
export class AuditTrailModule { }
